document.addEventListener('DOMContentLoaded', function () {

  if (window.MD_Firebase) {
    window.MD_Firebase.init();
  }

});